import { render, staticRenderFns } from "./DistributionByPercentage.vue?vue&type=template&id=6690430f&"
import script from "./DistributionByPercentage.vue?vue&type=script&lang=js&"
export * from "./DistributionByPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports